import { ReviewService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as review from './types';
//import * as common from '@common/store/modules/common/types';
//import * as commonGetters from '@common/store/modules/common/getters';

const actions = {
  async [review.CREATE_REVIEW](context, params) {
    const { data } = await ReviewService.add(params);
    return data;
  },
  async [review.DELETE_REVIEW](context, params) {
    const { data } = await ReviewService.remove(params);
    context.commit(review.SET_REVIEW, {});
    return data;
  },
  async [review.FETCH_REVIEW](context, params) {
    const { data } = await ReviewService.getById(params);
    context.commit(review.SET_REVIEW, data);
    return data;
  },
  async [review.FETCH_REVIEWS](context, params) {
    const { data } = await ReviewService.search(params);
    context.commit(review.SET_REVIEWS, data);
    return data;
  },
  async [review.REPORT_REVIEW](context, params) {
    const { data } = await ReviewService.report(params);
    return data;
  },
  async [review.REPORT_REVIEW_USER](context, params) {
    const { data } = await ReviewService.reportUser(params);
    return data;
  },
  async [review.UPDATE_REVIEW_VISIBLE](context, params) {
    const { data } = await ReviewService.modifyVisible(params);
    return data;
  },

  async [review.FETCH_REVIEW_REPORTS](context, params) {
    const { data } = await ReviewService.getReportList(params);
    context.commit(review.SET_REPORTS, data);
    return data;
  },

  async [review.FETCH_ALL_REVIEW_REPORTS](context, params) {
    const { data } = await ReviewService.getAllReportList(params);
    context.commit(review.SET_REPORTS, data);
    return data;
  },

  async [review.UPDATE_REVIEW_REPORT_VISIBLE](context, params) {
    const { data } = await ReviewService.modifyReportVisible(params);
    return data;
  },

  async [review.FETCH_REVIEW_CHECK](context, params) {
    const { data } = await ReviewService.check(params);
    return data;
  },
  async [review.FETCH_REVIEW_SCORE](context, parmas) {
    const { data } = await ReviewService.getScore(parmas);
    return data;
  },
  async [review.UPDATE_REVIEW_CHOICE_COUNT](context, parmas) {
    const { data } = await ReviewService.choiceCount(parmas);
    return data;
  },
  async [review.FETCH_REVIEW_POPUP](context, parmas) {
    const { data } = await ReviewService.reviewPopup(parmas);
    return data;
  },
  async [review.UPDATE_REVIEW_POPUP](context, parmas) {
    const { data } = await ReviewService.reviewPopupComfirm(parmas);
    return data;
  },
  async [review.SELECT_REVIEWS](context, params) {
    const { data } = await ReviewService.getReviews(params);
    return data;
  },
};

export default actions;
